import { Container, Grid, Box, Typography } from "@mui/material";

import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";

const services = [
  {
    id: "01",
    icon: <AutoAwesomeMosaicOutlinedIcon sx={{ fontSize: "80px" }} />,
    title: "General Construction",
    desc: "We deliver reliable construction services with a strong focus on quality, safety, and long-term durability.",
  },
  {
    id: "02",
    icon: <ConstructionOutlinedIcon sx={{ fontSize: "80px" }} />,
    title: "Property Maintenance",
    desc: "Comprehensive maintenance solutions ensuring operational efficiency and asset longevity.",
  },
  {
    id: "03",
    icon: <EngineeringOutlinedIcon sx={{ fontSize: "80px" }} />,
    title: "Sand & Stone Supply",
    desc: "High-quality sand and stone supply services for construction projects of all sizes.",
  },
  {
    id: "04",
    icon: <AccountTreeOutlinedIcon sx={{ fontSize: "80px" }} />,
    title: "Virtual Design & Build",
    desc: "Digital-first design approaches that minimize risks and improve build accuracy.",
  },
  {
    id: "05",
    icon: <ApartmentOutlinedIcon sx={{ fontSize: "80px" }} />,
    title: "Preconstruction",
    desc: "Strategic planning, budgeting, and feasibility analysis before execution begins.",
  },
  {
    id: "06",
    icon: <MapsHomeWorkOutlinedIcon sx={{ fontSize: "80px" }} />,
    title: "Raw & Aggregate Materials",
    desc: "Reliable sourcing and delivery of raw materials and aggregates for construction needs.",
  },
];

const AboutCards = () => {
  return (
    <Box sx={{ backgroundColor: "#F6F7F9" }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Grid container spacing={4}>
          {services.map((item) => (
            <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={item.id}>
              <Box
                sx={{
                  position: "relative",
                  height: "100%",
                  p: 4,
                  borderRadius: 2,
                  backgroundColor: "#fff",
                  boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.1)",

                    "& .service-icon": {
                      transform: "rotateY(180deg)",
                    },
                  },
                }}
              >
                {/* Large Number */}
                <Typography
                  sx={{
                    position: "absolute",
                    top: 16,
                    right: 20,
                    fontSize: "4rem",
                    fontWeight: 700,
                    color: "#5154781a",
                    lineHeight: 1,
                  }}
                >
                  {item.id}
                </Typography>

                {/* Icon */}
                <Box
                  className="service-icon"
                  sx={{
                    color: "#ffb400",
                    mb: 2,
                    width:"fit-content",
                    transition: "transform 0.6s ease",
                    // transformStyle: "preserve-3d",
                  }}
                >
                  {item.icon}
                </Box>

                {/* Content */}
                <Typography
                  variant="h6"
                  sx={{ fontSize: "22px", fontWeight: "600" }}
                  gutterBottom
                >
                  {item.title}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutCards;
